module.exports = __webpack_public_path__ + "static/media/ear-nose-throat-icon-mobile-menu.70bed71c.svg";